module.exports = __webpack_public_path__ + "img/footer_company_03.c7d43767.png";